export default function HelpCenterPdfIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="107"
      height="141"
      viewBox="0 0 107 141"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M52.9413 0L53.2108 0.27L53.3306 41.22L42.968 41.3V82.26L53.111 82.33L53.3206 91.03H49.1177L49.0977 109.74L43.8066 104.5L38.0063 110.32L53.2308 125.57L53.2108 140.24H0V0H52.9413ZM22.5422 65.88L27.5838 65.85C34.1827 65.31 39.0845 59.69 38.8748 53.2C38.6752 46.85 33.5937 41.34 27.0247 41.32L14.306 41.29V82.29H22.5123L22.5322 65.89L22.5422 65.88Z"
        fill="#F3F5F9"
      />
      <path
        d="M79.5165 0.280018L79.4766 27.25L106.411 27.22V140.23H53.2006L53.2206 125.56L68.4551 110.33L62.6149 104.46L57.3038 109.71L57.2838 91.04H53.3005L53.0908 82.33C60.5783 83.07 67.5366 78.09 67.5366 70.21V53.34C67.5366 45.58 60.718 40.53 53.3105 41.22L53.1907 0.27002H79.4966L79.5165 0.280018ZM88.0123 57.68H79.826V49.48H92.1054V41.28H71.6098V82.29H79.816V65.89H88.0023V57.69L88.0123 57.68Z"
        fill="#E1E6F0"
      />
      <path
        d="M22.5424 65.88L22.5224 82.28H14.3162V41.28L27.0349 41.31C33.6038 41.33 38.6853 46.84 38.885 53.19C39.0946 59.68 34.1929 65.31 27.5939 65.84L22.5524 65.87L22.5424 65.88ZM27.1347 57.6C29.4408 57.32 30.8584 55.24 30.6588 53.18C30.4791 51.25 28.8718 49.5 26.7453 49.5H22.5224V57.67L27.1247 57.61L27.1347 57.6Z"
        fill="#DB392F"
      />
      <path
        d="M53.3307 41.22L53.2108 49.48L51.1743 49.54V74.02L53.2108 74.08L53.111 82.33L42.968 82.26V41.3L53.3307 41.22Z"
        fill="#DB392F"
      />
      <path
        d="M53.3207 91.03L53.2308 125.56L38.0063 110.31L43.8066 104.5L49.0978 109.74L49.1177 91.04L53.3207 91.03Z"
        fill="#DB392F"
      />
      <path
        d="M88.0126 57.68V65.88L79.8264 65.89V82.28L71.6201 82.29V41.27L92.1058 41.28L92.1158 49.48H79.8364L79.8264 57.67L88.0126 57.68Z"
        fill="#C13929"
      />
      <path
        d="M53.1111 82.3301L53.2109 74.0801L55.8465 73.9801C57.8432 73.9101 59.2807 72.0501 59.2807 69.9801V53.5801C59.2807 51.5001 57.8432 49.9301 55.8465 49.5801L53.2109 49.4901L53.3307 41.2401C60.7383 40.5501 67.5569 45.6001 67.5569 53.3601V70.2301C67.5569 78.1101 60.5985 83.0901 53.1111 82.3501V82.3301Z"
        fill="#C13929"
      />
      <path
        d="M106.421 27.22L79.4866 27.25L79.5165 0.280029L106.421 27.22Z"
        fill="#C13929"
      />
      <path
        d="M53.2307 125.56L53.3206 91.03L57.3039 91.04L57.3239 109.71L62.625 104.46L68.4652 110.33L53.2307 125.56Z"
        fill="#C13929"
      />
      <path
        d="M27.1345 57.6L22.5322 57.66V49.48H26.7551C28.8816 49.48 30.4789 51.23 30.6686 53.16C30.8683 55.23 29.4506 57.3 27.1445 57.58L27.1345 57.6Z"
        fill="#F3F5F9"
      />
      <path
        d="M53.2107 49.48V74.08L51.1741 74.02V49.54L53.2107 49.48Z"
        fill="#F3F5F9"
      />
      <path
        d="M53.2107 74.08V49.48L55.8463 49.57C57.8429 49.93 59.2805 51.49 59.2805 53.57V69.97C59.2805 72.05 57.8429 73.9 55.8463 73.97L53.2107 74.07V74.08Z"
        fill="#E1E6F0"
      />
    </svg>
  );
}
